import { useMemo } from "react";
import { Nothing } from "~/components/permission/Nothing";
import { filled } from "~/util";
import type { BaseTextProps } from "./BaseText";
import { BodyText } from "./BodyText";

export type ParagraphsProps = {
    content?: string | null;
} & Omit<BaseTextProps, "children">;

export const Paragraphs = ({ content, size = "md", ...textProps }: ParagraphsProps) => {
    const lines = useMemo(() => (content ?? "")?.replace(/[\r\n]+/g, "\n"), [content]);

    return filled(lines) ? (
        <BodyText {...textProps} size={size}>
            {lines}
        </BodyText>
    ) : (
        <Nothing />
    );
};
